import { INVENTORY_TYPE } from '@/const/types/inventory';

export const INVENTORY_TYPE_MAP: {
    [key: number]: string;
} = {
    [INVENTORY_TYPE.banner]: 'Banner' as string,
    [INVENTORY_TYPE.interstitial]: 'Interstitial' as string,
    [INVENTORY_TYPE.native]: 'Native' as string,
    [INVENTORY_TYPE.rewardVideo]: 'Reward Video' as string,
}